import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as selectors from '../../selectors';
import { components as Core, translate, valueBuilder } from '../../../core';
import UserActivities from '../UserActivities';
import UserNotifications from '../UserNotifications';
import * as actions from '../../actions';
import { UnlinkComrcePopover } from './UnlinkComrcePopover';

const FIELDS = {
    fullName: 'fullName',
    email: 'email',
    lastLogin: 'lastLogin',
    phone: 'phone',
    preferedLanguageCode: 'preferedLanguageCode'
};

const COLLAPSE_ITEMS = {
    activities: 'activities'
};

class UserDetailsModal extends React.PureComponent {
    static propTypes = {
        i18n: PropTypes.object.isRequired,
        actions: PropTypes.object.isRequired,
        userId: PropTypes.string.isRequired, //eslint-disable-line
        user: PropTypes.object.isRequired,
        onClose: PropTypes.func.isRequired,
        isRevokeAllAuthorizations: PropTypes.bool,
        isUnlinkingComrceOAuth: PropTypes.bool,
        isDisableTwoFA: PropTypes.bool
    };

    static defaultProps = {
        isRevokeAllAuthorizations: false,
        isUnlinkingComrceOAuth: false,
        isDisableTwoFA: false
    };

    constructor(props) {
        super(props);
        const { i18n } = this.props;
        this.fields = [
            {
                fieldName: FIELDS.fullName,
                label: i18n.t('users.fullName')
            },
            {
                fieldName: FIELDS.email,
                label: i18n.t('users.email')
            },
            {
                fieldName: FIELDS.lastLogin,
                label: i18n.t('users.lastLogin'),
                render: valueBuilder.getLocalFullTime
            },
            {
                fieldName: FIELDS.phone,
                label: i18n.t('users.phone')
            },
            {
                fieldName: FIELDS.preferedLanguageCode,
                label: i18n.t('users.preferedLanguageCode')
            }
        ];
    }

    get renderActivitiesTable() {
        return <UserActivities userId={this.props.userId} />;
    }

    get renderNotificationsTable() {
        return <UserNotifications userId={this.props.userId} />;
    }

    get collapseData() {
        const { i18n } = this.props;
        return [
            {
                key: COLLAPSE_ITEMS.activities,
                title: i18n.t('users.userActivities'),
                content: this.renderActivitiesTable
            }
        ];
    }

    get collapseNotifications() {
        const { i18n } = this.props;
        return [
            {
                key: COLLAPSE_ITEMS.activities,
                title: i18n.t('users.userNotifications'),
                content: this.renderNotificationsTable
            }
        ];
    }

    get footer() {
        const {
            isRevokeAllAuthorizations,
            isUnlinkingComrceOAuth,
            isDisableTwoFA,
            user,
            i18n
        } = this.props;
        const hasComrceLink = user && user.comrceLinkedEmail;

        return (
            <div style={{ display: 'flex', gap: '10px' }}>
                <Core.Button
                    label={i18n.t('users.revokeAllAuthorizations')}
                    onPress={this.revokeAllAuthorizations}
                    isLoading={isRevokeAllAuthorizations}
                />
                {user.enable2FA && (
                    <Core.Button
                        label={i18n.t('users.disableTwoFA')}
                        onPress={this.disableTwoFA}
                        isLoading={isDisableTwoFA}
                    />
                )}
                {hasComrceLink && (
                    <UnlinkComrcePopover
                        onPress={this.unlinkComrceOAuth}
                        isLoading={isUnlinkingComrceOAuth}
                    />
                )}
            </div>
        );
    }

    revokeAllAuthorizations = () => {
        this.props.actions.revokeAllAuthorizations(this.props.userId);
    };

    unlinkComrceOAuth = () => {
        this.props.actions.unlinkComrceOAuth(this.props.userId);
    };

    disableTwoFA = () => {
        this.props.actions.disableTwoFA(this.props.userId);
    };

    render() {
        const { i18n, onClose, user } = this.props;
        return (
            <Core.Modal
                isVisible={true}
                onClose={onClose}
                title={i18n.t('users.userDetails')}
                footer={this.footer}
            >
                <div>
                    <Core.FieldsGenerator fields={this.fields} data={user} />
                    <Core.Collapse data={this.collapseData} />
                    <Core.Collapse data={this.collapseNotifications} />
                </div>
            </Core.Modal>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    user: ownProps.isUserFromAll
        ? selectors.getUserFromAll(state, ownProps.userId)
        : selectors.getUser(state, ownProps.userId),
    isRevokeAllAuthorizations: selectors.isRevokeAllAuthorizations(state, ownProps.userId),
    isUnlinkingComrceOAuth: selectors.isUnlinkingComrceOAuth(state, ownProps.userId),
    isDisableTwoFA: selectors.isDisableTwoFA(state, ownProps.userId)
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(actions, dispatch)
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(translate()(UserDetailsModal));
